import { useMediaQuery } from 'react-responsive'

const useIsMobile = (maxWidth) => {
  const isMobile = useMediaQuery({ maxWidth: maxWidth || 1200 })
  return isMobile
};

export default useIsMobile
